<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="addActivity">新增</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item label="活动状态">
        <el-select ref="statusBox" v-model="search.status" placeholder="选择活动状态">
          <el-option label="全部" value="" />
          <el-option v-for="item in statusList" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item class="search-form-item">
        <el-input v-model="search.title" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%">
      <el-table-column prop="id" label="活动ID" width="100" fixed />
      <el-table-column prop="title" label="活动标题" width="auto" fixed />
      <el-table-column label="活动日期" width="auto">
        <template #default="{row}">
          {{ $moment(row.startDate).format('YYYY/MM/DD')+' - '+$moment(row.endDate).format('YYYY/MM/DD') || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="活动状态" align="center" width="auto">
        <template v-slot="{row}">
          <el-tag :style="{'color':statusList.find(item=>item.id == row.status).color,'borderColor':statusList.find(item=>item.id == row.status).borderColor,'backgroundColor':statusList.find(item=>item.id == row.status).bgColor}" class="" size="mini">{{ statusList.find(item=>item.id == row.status).value || '--' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="500" label="操作">
        <template v-slot="{row}">
          <el-button v-if="row.status ==5" size="small" type="text" class="link-color" @click="previewActivity(row)">查看</el-button>
          <el-button v-if="row.status !=5" size="small" type="text" class="link-color" @click="editActivity(row)">编辑</el-button>
          <el-button size="small" type="text" class="link-color" @click="copyLink(row)">复制链接</el-button>
          <el-button v-if="row.status ==1" size="small" type="text" class="link-color" @click="releaseActivity(row)">发布</el-button>
          <el-button v-if="row.status ==2" size="small" type="text" class="link-color" @click="cancelReleaseActivity(row)">取消发布</el-button>
          <el-button v-if="row.status ==4" size="small" type="text" class="link-color" @click="postOfflineTask(row)">下架</el-button>
          <el-button size="small" type="text" class="link-color" @click="exportEnrollmentList(row)">报名名单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background class="fixed-below" :page-size="currentPage.limit" :page-sizes="[10, 20, 50, 100]" :current-page.sync="currentPage.current" :total="currentPage.total" layout="total, prev, pager, next, sizes" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSuccess" />
  </div>
</template>
<script>
import Dialog from '@/components/Dialog';
export default {
  components: { Dialog },
  data() {
    const statusList = [
      { id: 1, value: '草稿', color: '#EA9921', borderColor: '#ea9921b3', bgColor: '#ea99211a' },
      { id: 2, value: '已发布', color: '#60AC56', borderColor: '#60ac56b3', bgColor: '#60ac561a' },
      { id: 3, value: '进行中', color: '#1890FF', borderColor: '#1890ffb3', bgColor: '#1890ff1a' },
      { id: 4, value: '已结束', color: '#9B9B9B', borderColor: '#9b9b9bb3', bgColor: '#9b9b9b1a' },
      { id: 5, value: '已下架', color: '#9B9B9B', borderColor: '#9b9b9bb3', bgColor: '#9b9b9b1a' },
    ];
    return {
      statusList,
      search: {
        title: "",
        status: "",
      },
      list: [],
      currentPage: {
        current: 1,
        limit: 10,
        total: 0,
      },
      currentID: -1,
      formDialogShow: false,
      information: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    searchSubmit() {
      this.currentPage.current = 1;
      this.getList();
    },
    reset() {
      this.search = { title: '', status: '' };
      this.currentPage.current = 1;
      this.getList();
    },
    getList() {
      this.$Api.newCamp.campSetList({ ...this.search, ...this.currentPage }).then(res => {
        if (res) {
          console.log('res', res);
          this.list = res.data;
          this.currentPage.total = res.total;
        }
      });
    },
    editActivity(row) {
      this.currentStatus = row.status;
      this.openDialog(row, {
        operation: 'edit',
        icon: 'warn',
        subTitle: `是否确认编辑活动ID为“${row.id}”的数据项？`,
      });
    },
    previewActivity(row) {
      this.$router.push({ path: `/online_activity/meridianCamp/edit`, query: { id: row.id, type: 'preview' } });
    },
    copyLink(row) {
      // CAMP 小程序路径
      let page = `/pages-camp/camp/index?id=`;
      if (!row.id) return;
      page += row.id;
      navigator.clipboard.writeText(page).then(() => {
        this.$message.success('复制成功');
      }).catch(() => {
        this.$message.error('复制失败');
      });
    },
    releaseActivity(row) {
      this.openDialog(row, {
        operation: 'release',
        icon: 'warn',
        subTitle: `是否确认发布活动ID为“${row.id}”的数据项？`,
      });
    },
    cancelReleaseActivity(row) {
      this.openDialog(row, {
        operation: 'cancelRelease',
        icon: 'warn',
        subTitle: `是否确认取消发布活动ID为“${row.id}”的数据项？`,
      });
    },
    postOfflineTask(row) {
      this.openDialog(row, {
        operation: 'offline',
        icon: 'warn',
        subTitle: `是否确认下架活动ID为“${row.id}”的数据项？`,
      });
    },
    submitSuccess(operation) {
      const typeList = ['copy', 'edit', 'preview'];
      if (typeList.includes(operation)) {
        this.$router.push({ path: `/online_activity/meridianCamp/edit`, query: { id: this.currentID, type: operation, status: this.currentStatus } });
        return;
      }
      if (operation === 'release') {
        this.$Api.newCamp.campSetRelease(this.currentID).then(() => {
          this.$message.success('发布成功');
          this.getList();
        });
        return;
      }
      if (operation === 'cancelRelease') {
        this.$Api.newCamp.campSetCancelRelease(this.currentID).then(() => {
          this.$message.success('取消发布成功');
          this.getList();
        });
        return;
      }
      if (operation === 'offline') {
        this.$Api.newCamp.campSetRemoveShelf(this.currentID).then(() => {
          this.$message.success('下架成功');
          this.getList();
        });
        return;
      }
    },
    addActivity() {
      this.$router.push({ path: '/online_activity/meridianCamp/add' });
    },
    handleSizeChange(value) {
      this.currentPage.limit = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.currentPage.current = value;
      this.getList();
    },
    openDialog(row, { operation, icon, subTitle }) {
      this.formDialogShow = true;
      row && (this.currentID = row.id);
      this.information = { operation, icon, subTitle };
    },
    exportEnrollmentList(row) {
      this.$Api.newCamp.campSetExportEnrollmentList(row.id).then(res => {
        if (!res) {
          this.$message.error('该活动暂无报名人员');
        } else {
          this.$message.success('导出成功');
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.el-dialog__wrapper {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .share-wrapper {
    width: 580px;
    margin: unset !important;
    .el-dialog__header {
      height: 6.85vh !important;
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 20px 30px 30px;
      .upload-wrap {
        width: 100%;
        height: 236px;
        background: #f7f7f7;
        border: 1px dashed #bbbbbb;
        border-radius: 4px;
        padding: 20px 30px;
        box-sizing: border-box;
        .el-upload-dragger {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .tips {
          font-family: "Noto Sans SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #494949;
          margin-bottom: 20px;
        }
        .upload-box {
          width: 100%;
          height: 156px;

          .el-upload.el-upload--text {
            width: 100%;
            height: 100%;
            .el-upload-dragger {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #bbbbbb;
              border-radius: 4px;
              &:hover {
                border-color: #1c1c1c;
              }
              .file {
                line-height: 20px;
                margin-top: 5.68px;
              }
              .el-button {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
    .btns {
      justify-content: center;
      margin-top: 30px;
      .el-button {
        width: 120px;
        height: 50px;
      }
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}

.el-pagination {
  padding-left: 30px;
}
</style>
